module.exports = {"511502001":"北城街道","511502002":"东城街道","511502003":"南城街道","511502004":"西城街道","511502005":"南岸街道","511502006":"西郊街道","511502007":"安阜街道","511502008":"白沙湾街道","511502009":"赵场街道","511502010":"象鼻街道","511502011":"沙坪街道","511502100":"南广镇","511502101":"李庄镇","511502102":"菜坝镇","511502104":"金坪镇","511502106":"高店镇","511502108":"牟坪镇","511502109":"李端镇","511502110":"邱场镇","511502111":"宗场镇","511502112":"宋家镇","511502201":"明威乡","511502202":"凉姜乡","511502204":"思坡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511502.json
// module id = 2172
// module chunks = 0